<script>
	import { onMount, onDestroy } from "svelte";
	import {
		Accordion,
		AccordionItem,
		Col,
		Row,
	} from "@sveltestrap/sveltestrap";
	import { navigate } from "svelte-routing";
	import {
		loading,
		imageLightbox,
		pendingIssueCarSection,
		errorMessage,
	} from "../../../../../store/store";
	import VehiclePendingIssue from "./VehiclePendingIssue.svelte";
	import LoaderContainer from "../../../../../components/Loader/LoaderContainer.svelte";
	import SwitchComponent from "./SwitchComponent.svelte";
	import PageHeader from "../../../../../components/PageHeader/PageHeader.svelte";
	import client from "../../../../../services/client";
	import Swal from "sweetalert2";
	import ErrorMessageHandler from "../../../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";

	let issues;
	let img_url = [];
	let carSection;

	export let vehicleId;

	//For loading the page for specific vehicle
	onMount(async () => {
		try {
			loading.set(true);
			const res = await client(
				`/v0/Issue/v2/GetPendingIssues/${vehicleId}`,
				{
					method: "GET",
					version: "Tasking",
				}
			);
			if (res.data.data != null) {
				issues = res.data.data;
				img_url = issues.imageUrls;

				if (issues.carSection != null) {
					let lowerCaseCarSection = issues.carSection.toLowerCase();
					carSection =
						lowerCaseCarSection.charAt(0).toUpperCase() +
						lowerCaseCarSection.slice(1);
				}

				pendingIssueCarSection.set(carSection);
				imageLightbox.set(img_url);
			} else {
				Swal.fire({
					title: "Warning",
					text: res.data.error_msg,
					showCancelButton: false,
					confirmButtonColor: "#006DE1",
					timer: 8000,
					confirmButtonText: "Okay",
				});
				navigate("/issue-management/vehicle-issues");
			}
			loading.set(false);
		} catch (err) {
			loading.set(false);

			console.log(err);
			console.log(err.response);
		}
	});

	// For fetching issue whenever pending issues
	const fetchIssue = async (req, res) => {
		try {
			loading.set(true);
			const res = await client(
				`/v0/Issue/v2/GetPendingIssues/${vehicleId}`,
				{
					method: "GET",
					version: "Tasking",
				}
			);
			issues = res.data.data;
			loading.set(false);
		} catch (err) {
			loading.set(false);

			console.log(err);
			console.log(err.response);
		}
	};

	// Vehicle Search function disabled
	const trigerAlert = setTimeout(
		() => {
			Swal.fire({
				title: "Session expiring",
				text: "Your session will expire in 60 seconds. Do you want to extend the session?",
				showCancelButton: true,
				confirmButtonColor: "#006DE1",
				timer: 60000,
				cancelButtonColor: "red",
				confirmButtonText: "Extend session",
				cancelButtonText: "Leave session",
			}).then(async (result) => {
				if (result.isConfirmed) {
					const res = await client(
						`/api/Issue/ExtendSession/${issues.issueId}`,
						{
							method: "POST",
							version: "Tasking",
						}
					);
					if (res.data.error_code == 0) {
						Swal.fire("Your session has been extended!");
					} else {
						navigate("/issue-management/vehicle-issues");
					}
				} else {
					navigate("/issue-management/vehicle-issues");
				}
			});
		},
		15 * 60 * 1000
	);

	onDestroy(() => {
		clearTimeout(trigerAlert);
	});
</script>

{#if !issues}
	<LoaderContainer />
{:else}
	<LoaderContainer>
		<Row class="flex-row">
			<Col xs={12}>
				<ErrorMessageHandler message={$errorMessage} />
				<Col className="row align-items-start mx-0">
					<PageHeader title="Vehicle Issues" />
				</Col>
				<div class="d-flex flex-row justify-content-between">
					<Col xs={4}>
						<div
							class="d-flex justify-content-between status-bar-4 status-bar-info-4"
						>
							<b>Vehicle Number</b>
							<b>{issues.vehicleNumber}</b>
						</div>
					</Col>
				</div>
			</Col>
		</Row>
		<br />
		<Row>
			<Col xs="6">
				<Accordion>
					<AccordionItem active="true">
						<span slot="header"><b>Pending Issues</b></span>
						<VehiclePendingIssue {issues} {img_url} {fetchIssue} />
					</AccordionItem>
				</Accordion>
			</Col>
			<Col xs="6">
				<SwitchComponent {issues} {img_url} {vehicleId} />
			</Col>
		</Row>
	</LoaderContainer>
{/if}
